import styled from 'styled-components';

export const List = styled.ol`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

export const Info = styled.div`
  margin-left: 26px;
`;

export const Item: any = styled.li`
  display: flex;
  align-items: center;
  padding: 18px 0 18px 41px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.navigationMenu.border};

  &:hover {
    background-color: ${({ theme }) => theme.navigationMenu.background};
  }
`;

Item.Icon = styled.span`
  & > svg {
    font-size: 2em;
    margin-left: 10px;
  }
`;

Item.Name = styled.span`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.userMenu.nameColor};
`;

Item.Detail = styled.span`
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: ${({ theme }) => theme.userMenu.color};
`;
